import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { messages } from '../../../messages';
import { openEmbedModal } from '../../EmbedModal/utils';

/*
Most of these are optional as we are being fault-tolerant
However src, details, icon, title, and providerName are STRONGLY encouraged
*/

export default (({
  details,
  ...rest
}) => ({
  id: 'preview-content',
  text: /*#__PURE__*/React.createElement(FormattedMessage, messages.preview_improved),
  promise: () => openEmbedModal({
    providerName: 'Preview',
    showModal: true,
    onClose: () => {},
    ...rest
  })
}));